import { render } from "./analyticsView.vue?vue&type=template&id=87b23666"
import script from "./analyticsView.vue?vue&type=script&lang=js"
export * from "./analyticsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__